import { put, select, takeLatest } from 'redux-saga/effects'
import { PatientAllergiesConstants } from '../store/patientAllergies.constants'
import { getPatientAllergiesSelector, getPatientAllergySelector } from '../selectors'
import { IAllergyOptions } from '../store/patientAllergies.types'
import { saveAllergies } from '../store/patientAllergies.actions'
import { getPcrIdSelector } from '../../home/selectors'
import { getPatientAllergyOptionsSelector } from '../../options/selectors'

export function* deleteAllergies() {
  const patientAllergies = yield select(getPatientAllergiesSelector)

  const { allergies } = patientAllergies
  const { transformedChunkedPatientAllergyOptions } = yield select(getPatientAllergyOptionsSelector)
  const allergyToDelete = yield select(getPatientAllergySelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const newAllergiesList = allergies.filter((allergy: IAllergyOptions) => {
      if (allergy.id !== 0) {
        return allergy.id !== allergyToDelete.id
      } else {
        return allergy.name !== allergyToDelete.name
      }
    })

    yield put(saveAllergies(newAllergiesList))
    transformedChunkedPatientAllergyOptions.map((pa: IAllergyOptions) => {
      if (pa.id === allergyToDelete.id) {
        pa.selected = false
      }
    })
  } else {
    // todo: add to audit log
  }
}
export function* deleteAllergiesSaga() {
  yield takeLatest([PatientAllergiesConstants.DELETE_ALLERGY], deleteAllergies)
}
